import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const routeAPI = {
  uploadCSV: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axios.post(`${BACKEND_URL}/api/cb-routes/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    
    return response.data;
  },

  getRoutesCount: async () => {
    const response = await axios.get(`${BACKEND_URL}/api/cb-routes/count`);
    return response.data;
  },

  findOptimalRoute: async (corridor, currency, amount) => {
    const response = await axios.post(`${BACKEND_URL}/api/find-optimal-route`, {
      corridor,
      currency,
      amount
    });
    
    return response.data;
  }
};
